<template>
  <div class="app-container">
    <el-dialog
      :width="handleCommon('dialog.medium')"
      title="反應詳情"
      :close-on-click-modal="false"
      :visible.sync="detailDialogVisible"
      @close="handleCancel">
        反應內容：<br>{{ this.handleStateGetter('editData.content') }}
        <br><br>
        客服回覆：<br>{{ this.handleStateGetter('editData.remark') || '無' }}
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  data() {
    return {
      moduleName: 'contact'
    }
  },
  computed: {
    detailDialogVisible: {
      get() {
        return this.handleStateGetter('detailDialogVisible')
      },
      set(val) {
        this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'detailDialogVisible', val)
      }
    }
  },
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    },
    handleCancel() {
      this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'detailDialogVisible', false)
    },
    handleStateSetter(m, k, v) {
      this.$store.commit(m, { key: k, val: v })
    },
    handleStateGetter(k) {
      return eval(`this.$store.state.${this.moduleName}.${k}`)
    }
  }
}
</script>
